export default {
  pubnubPresenceTimeoutSeconds: 30,
  pubnubHeartbeatIntervalSeconds: 15,
};
